/**
 * This controls the sticky header (data-header-wrapper), which contains the announcement bar and header.
 */

/**
 * Variables
 * @var {number} lastScrollPosition - the last-scrolled to position on the y-axis
 * @var {boolean} hasScrolled - whether the user has scrolled or not
 * @var {minScrollDistance} - the minimum distance the user needs to scroll to register in the fuction
 */

let lastScrollPosition = 0;
let hasScrolled;
let minScrollDistance = 5;

/**
 * On window scroll, set 'hasScrolled' to true so that we update the header visibility
 */
window.addEventListener('scroll', () => { hasScrolled = true; });

/**
 * If 'hasScrolled' is true, call setHeaderState() and set it back to false.
 * This is inside an interval because tracking 'scroll' events causes a LOT of events, and we don't want to overload the browser. This way only calls it every 250ms.
 */
setInterval(() => {
  if (hasScrolled) {
    setHeaderState();
    hasScrolled = false;
  }
}, 250);

/**
 * 
 * @var {number} currentScrollPosition - the currently scrolled-to position on the y-axis
 * @var {boolean} scrollingUp - whether or not the last scroll was up or down the y-axis
 * @var {string} headerVisible - the value of the [data-header-state] on the body. only 'hidden' or 'visible'. triggers CSS transform
 * @var {boolean} pastInitialLoadHeight - whether or not the current scroll position is past the initial load height of the browser
 */
function setHeaderState() {
  const currentScrollPosition = window.scrollY;

  const scrollingUp = currentScrollPosition < lastScrollPosition;

  const headerVisible = document.body.getAttribute('data-header-state') === 'visible';

  const pastInitialLoadHeight = currentScrollPosition >= (window.innerHeight);


  // if scrolled to the top of the page, return
  if (currentScrollPosition <= 0) return;

  // if they haven't scrolled more than 5px, return
  if (Math.abs(lastScrollPosition - currentScrollPosition) <= minScrollDistance) return;

  // if scrolling up and header is hidden
  if (scrollingUp && !headerVisible) { 
    document.body.setAttribute('data-header-state', 'visible');
    return;
  }

  // if scrolling down and header is hidden and within initial load area
  if (!scrollingUp && !headerVisible && !pastInitialLoadHeight) {
    document.body.setAttribute('data-header-state', 'visible');
    return;
  }

  // if scrolling down and header is visible and out of initial load area
  if (!scrollingUp && headerVisible && pastInitialLoadHeight) {
    document.body.setAttribute('data-header-state', 'hidden');
    return;
  }

  // update the last scrolled-to position
  lastScrollPosition = currentScrollPosition;
}
